// extracted by mini-css-extract-plugin
export default {"body":"styles_body__JOfad","body--new-chat":"styles_body--new-chat__SVtYd"};